import { render, staticRenderFns } from "./MailConfirmationConfirmed.vue?vue&type=template&id=66181631"
import script from "./MailConfirmationConfirmed.vue?vue&type=script&lang=js"
export * from "./MailConfirmationConfirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports